// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createBlockRequestToJson, createBlockResponseFromJson, deleteBlockRequestToJson, getBlockRequestToJson, getBlockResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createBlock(request) {
    const raw = await fetchRpc('email.v1.Blocks/CreateBlock', createBlockRequestToJson(request));
    return createBlockResponseFromJson(raw);
}
export function createBlock$(request, options) {
    return defer(() => createBlockWithTransport$(getGlobalTransport(), request, options));
}
export function createBlockWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Blocks/CreateBlock', createBlockRequestToJson(request), options)
        .pipe(map(resp => createBlockResponseFromJson(resp)));
}
export async function getBlock(request) {
    const raw = await fetchRpc('email.v1.Blocks/GetBlock', getBlockRequestToJson(request));
    return getBlockResponseFromJson(raw);
}
export function getBlock$(request, options) {
    return defer(() => getBlockWithTransport$(getGlobalTransport(), request, options));
}
export function getBlockWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Blocks/GetBlock', getBlockRequestToJson(request), options)
        .pipe(map(resp => getBlockResponseFromJson(resp)));
}
export async function deleteBlock(request) {
    await fetchRpc('email.v1.Blocks/DeleteBlock', deleteBlockRequestToJson(request));
}
export function deleteBlock$(request, options) {
    return defer(() => deleteBlockWithTransport$(getGlobalTransport(), request, options));
}
export function deleteBlockWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Blocks/DeleteBlock', deleteBlockRequestToJson(request), options)
        .pipe(map(() => undefined));
}
